var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorksheetLg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6.99986C7 5.89531 7.8954 4.99989 8.99995 4.99986L23.2395 4.99951C23.7294 4.9995 24.2022 5.17927 24.5684 5.50474L32.3288 12.4033C32.7557 12.7829 33 13.3269 33 13.8981V32.9997C33 34.1043 32.1046 34.9997 31 34.9997H9C7.89543 34.9997 7 34.1043 7 32.9997V6.99986ZM13.4 14C12.6268 14 12 14.6268 12 15.4C12 16.1732 12.6268 16.8 13.4 16.8H26.6C27.3732 16.8 28 16.1732 28 15.4C28 14.6268 27.3732 14 26.6 14H13.4ZM12 21.4C12 20.6268 12.6268 20 13.4 20H26.6C27.3732 20 28 20.6268 28 21.4C28 22.1732 27.3732 22.8 26.6 22.8H13.4C12.6268 22.8 12 22.1732 12 21.4ZM13.4 26C12.6268 26 12 26.6268 12 27.4C12 28.1732 12.6268 28.8 13.4 28.8H26.6C27.3732 28.8 28 28.1732 28 27.4C28 26.6268 27.3732 26 26.6 26H13.4Z",
    fill: "#A140D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorksheetLg);
export default __webpack_public_path__ + "static/media/worksheet-lg.7d6ef28d0b37cf28d1add7535c6d1409.svg";
export { ForwardRef as ReactComponent };